// Regras do avatar do usuário, compartilhadas por components/AvatarUsuario.js,
// pelo seletor do Perfil e pelas Tarefas (docs/avatares.md).
import { resolveApiBaseURL } from '../services/api';

export const iniciais = (nome) => String(nome || '?')
  .split(/\s+/)
  .filter(Boolean)
  .slice(0, 2)
  .map((p) => p[0].toUpperCase())
  .join('') || '?';

// Cor fixa de cada pessoa sem avatar, derivada do id: a mesma em qualquer
// tela e navegador. Tons médios e bem distintos: contraste >= 4,5 com o texto
// branco e ainda visíveis no fundo escuro. Sem cinzas (somem nos fundos claro e
// escuro) e sem o roxo da marca, que nas Tarefas indica "play rodando".
export const CORES_DE_USUARIO = [
  '#2563eb', // azul
  '#c2410c', // laranja
  '#15803d', // verde
  '#be185d', // rosa
  '#0e7490', // ciano
  '#a16207', // âmbar
  '#b91c1c', // carmim
  '#0f766e', // verde-azulado
  '#a21caf', // fúcsia
  '#4d7c0f' // oliva
];

export const corDoUsuario = (id) => {
  const n = Math.abs(Math.trunc(Number(id) || 0));
  return CORES_DE_USUARIO[n % CORES_DE_USUARIO.length];
};

// caminho_arquivo da tabela `avatares`. Os DiceBear (/avatares/...) vêm do
// próprio frontend (public/avatares); um caminho de /uploads vem do backend.
export const urlDoAvatar = (caminho) => {
  if (!caminho) return null;
  if (/^https?:\/\//.test(caminho)) return caminho;
  if (caminho.startsWith('/uploads/')) return `${resolveApiBaseURL().replace(/\/api\/?$/, '')}${caminho}`;
  return `${process.env.PUBLIC_URL || ''}${caminho}`;
};

// Descrição do avatar no idioma da interface (alt no seletor).
export const descricaoDoAvatar = (avatar, idioma) => {
  if (!avatar) return '';
  const lang = String(idioma || 'pt').slice(0, 2);
  return avatar.descricoes?.[lang] || avatar.descricoes?.pt || avatar.nome || '';
};
